<template>
  <div class="guestCardRecharge">
    <div class="flex justify-space-between align-center">
      <h2 class="title"></h2>
      <router-link to="/" class="link">
        <span @click="clearRechargeFormState">&lt; Regresar</span>
      </router-link>
    </div>
    <div class="card flex dspl-block-sm">
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3>Recarga Tarjeta Acceso Digital Peatonal</h3>
        </div>
        <div class="flex justify-center dspl-block-m dspl-block-sm">
          <img src="@/assets/images/tarjeta_proximidad.png">
        </div>
        <GuestCardForm />
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import GuestCardForm from '@/components/Recharge/GuestCardForm'

export default {
  name: 'GuestCardRecharge',
  components: {
    GuestCardForm
  },
  methods: {
    ...mapActions('rechargeCardForm', [
      'clearRechargeFormState'
    ])
  }
}
</script>
<style scoped lang="scss">
.guestCardRecharge {
  padding: 2rem;
}
img {
  max-width: 50%;
}
@media screen and (max-width: 960px) {
  img {
    max-width: 100%;
  }
}
</style>
